<template>
  <div class="auth-content">
    <div class="auth-modal">
      <img src="@/assets/logo-login.png" width="200" :alt="$t('logo')" />
      <hr />
      <div class="auth-title">{{ showSignup ? $t('cadastro') : $t('login') }}</div>

      <b-form-input id="login" v-model="user.Username" type="text" :placeholder="$t('user-login')" />
      <b-form-input v-if="showSignup" v-model="user.email" name="email" type="text" :placeholder="$t('e-mail-1')" />
      <b-form-input v-model="user.UserPassword" id="password" type="password" :placeholder="$t('senha')"
        @keydown.enter="signin" />
      <b-form-input v-if="showSignup" v-model="user.confirmPassword" type="password"
        :placeholder="$t('confirme-a-senha')" />

      <b-button class="login-button" @click="signin">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        {{ $t('entrar') }} </b-button>
    </div>
  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "Auth",
  data: function () {
    return {
      showSignup: false,
      user: {},
      loading: false,
    };
  },
  methods: {
    b64_to_utf8(str) {
      while (str.length % 4 !== 0) {
        str += '=';
      }

      str = str.replace(/-/g, '+').replace(/_/g, '/');

      return decodeURIComponent(escape(window.atob(str)));
    },
    signin() {
      localStorage.clear();
      if (
        this.user.Username != undefined ||
        this.user.UserPassword != undefined
      ) {
        const obj = { ...this.user };

        obj.Username = window.btoa(unescape(encodeURIComponent(JSON.stringify(obj.Username))));
        obj.UserPassword = window.btoa(unescape(encodeURIComponent(JSON.stringify(obj.UserPassword))));
        this.loading = true;

        axios
          .post(`${urlMainAPI}/login`, obj)
          .then((res) => {
            let person = this.b64_to_utf8(res.data.token1.split(".")[1]);
            this.$store.commit("setToken", res.data.token2);
            localStorage.setItem("tk", res.data.token2);
            localStorage.setItem("isLDCSystem", res.data.isLDCSystem);

            person = JSON.parse(person);
            person.FullName = person.FullName.replace('TokenBase64', '');
            person.Permissions = JSON.parse(person.Permissions);

            this.$store.commit("setSystem", person.role);
            localStorage.setItem("system", person.role);
            this.$store.commit("setUser", person);
            localStorage.setItem("userKey", JSON.stringify(person));
            this.$store.commit("setTokenMaxTime", person.TokenMaxTime);
            localStorage.setItem("tokenMaxTime", person.TokenMaxTime);
            this.$store.commit("setUnitName", person.UnitName);
            localStorage.setItem("unitName", person.UnitName);

            this.setTitle(person)
            this.$store.dispatch("getOnlineModeStatus");

            this.$router.push({ path: "/" });

            defaultSuccess(this.$t('login-realizado-com-sucesso'));
            if (person.onlineType == "PGDI")
              this.loadActiveScenario();
          })
          .catch()
          .finally(() => {
            this.loading = false;
          });
      } else {
        showError(this.$t('usuario-ou-senha-nao-informado'));
      }
    },

    loadActiveScenario() {
      try {
        let url = `${urlMainAPI}/loadactivesimulationscenario`;
        axios
          .get(url)
          .then((res) => {
            let xml = {};
            xml.name = res.data.name;
            xml.scenario = res.data.scenario;
            xml.scenarioResult = res.data.scenarioResult;
            xml.scenarioObjectStructure = res.data.scenarioObjectStructure;

            this.$store.commit("setXML", xml);
            localStorage.setItem("xml", JSON.stringify(xml));

            this.$store.commit("setScenarioName", xml.name);
            localStorage.setItem("lastScenarioName", xml.name);
          })
          .catch();
      } catch (error) {
        showError(this.$t('problema-ao-carregar-o-modelo-ativo'));
      }
    },

    setTitle(person) {
      document.querySelector("head>title").innerHTML = "Pentagro", [person.onlineType, person.UnitName]
    }
  },
  created() {
    this.$store.commit("setMsgBoxState", false);
  }
};
</script>

<style>
.auth-content {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-modal {
  background-color: #fff;
  width: 350px;
  padding: 35px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.438);

  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
}

.auth-title {
  font-size: 1.2rem;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 15px;
}

.auth-modal input {
  border: 1px solid #bbb !important;
  width: 100%;
  margin-bottom: 15px;
  padding: 3px 8px;
  outline: none;
}

.auth-modal input:focus {
  border: 1px solid #bbb !important;
  box-shadow: 0px 0px 5px #bbb !important;
}

.auth-modal button {
  align-self: flex-end;
  background-color: #138076;
  color: #fff;
  padding: 5px 15px;
}

.auth-modal button:hover,
.auth-modal button:focus,
.auth-modal button:active {
  background-color: #138076 !important;
  color: #fff !important;
}

.auth-modal a {
  margin-top: 35px;
}

.auth-modal hr {
  border: 0;
  width: 100%;
  height: 1px;
  background-image: linear-gradient(to right,
      rgba(120, 120, 120, 0),
      rgba(120, 120, 120, 0.75),
      rgba(120, 120, 120, 0));
}

.login-button {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
